import { render, staticRenderFns } from "./kllk-backtop.vue?vue&type=template&id=7261d15a&scoped=true&"
import script from "./kllk-backtop.vue?vue&type=script&lang=js&"
export * from "./kllk-backtop.vue?vue&type=script&lang=js&"
import style0 from "./kllk-backtop.vue?vue&type=style&index=0&id=7261d15a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7261d15a",
  null
  
)

export default component.exports